import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowRightIcon, ShieldCheckIcon, ClockIcon, TargetIcon, LightbulbIcon, AwardIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function HomePage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fQiVNKChbSSmwHfHx7DNJE/IMG-20251022-WA0007.jpg',
    title: 'Tim Profesional yang Berdedikasi',
    subtitle: 'Crew terlatih dan berpengalaman siap melayani kebutuhan ground handling Anda'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7sazHs4UZuMPvQfzXDujJT/IMG-20251022-WA0010.jpg',
    title: 'Profesionalisme dan Dedikasi dalam Setiap Operasi Ground Handling',
    subtitle: 'Memberikan layanan ground handling terbaik dengan standar keselamatan tertinggi di seluruh Indonesia'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1fKhTRB3JEKkJMUQESwg4r/IMG-20251022-WA0008.jpg',
    title: 'Layanan Berkelas Internasional',
    subtitle: 'Standar pelayanan terbaik untuk setiap operasional penerbangan'
  }];
  const values = [{
    icon: ShieldCheckIcon,
    title: 'Keselamatan',
    description: 'Prioritas utama dalam setiap operasi'
  }, {
    icon: ClockIcon,
    title: 'Efisiensi',
    description: 'Layanan cepat dan tepat waktu'
  }, {
    icon: TargetIcon,
    title: 'Ketepatan',
    description: 'Presisi dalam setiap detail'
  }, {
    icon: LightbulbIcon,
    title: 'Inovasi',
    description: 'Terus berinovasi untuk kemajuan'
  }, {
    icon: AwardIcon,
    title: 'Keandalan',
    description: 'Partner terpercaya Anda'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  return <div className="w-full" data-id="element-291">
      <Helmet data-id="element-292">
        <title data-id="element-293">
          PT Jagat Indo Perkasa - Layanan Ground Handling Profesional Indonesia
          | Ramp, Passenger, Cargo
        </title>
        <meta name="description" content="PT Jagat Indo Perkasa adalah penyedia layanan ground handling terkemuka di Indonesia. Melayani 4 bandara strategis (HLP, BTW, BDJ, UPG) dengan layanan ramp handling, passenger service, cargo handling, dan flight support 24/7. Standar internasional IATA & ICAO." data-id="element-294" />
        <meta name="keywords" content="ground handling Indonesia, layanan bandara profesional, ramp handling, passenger service, cargo handling, PT Jagat Indo Perkasa, ground handling Jakarta, ground handling Kalimantan, ground handling Sulawesi, Halim Perdanakusuma, flight support, cabin cleaning, VIP protocol" data-id="element-295" />
        <meta name="author" content="PT Jagat Indo Perkasa" data-id="element-296" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" data-id="element-297" />
        <link rel="canonical" href="https://jagatindoperkasa.id/" data-id="element-298" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-299" />
        <meta property="og:url" content="https://jagatindoperkasa.id/" data-id="element-300" />
        <meta property="og:site_name" content="PT Jagat Indo Perkasa" data-id="element-301" />
        <meta property="og:title" content="PT Jagat Indo Perkasa - Layanan Ground Handling Profesional Indonesia" data-id="element-302" />
        <meta property="og:description" content="Penyedia layanan ground handling terkemuka di Indonesia dengan standar internasional. Melayani 4 bandara strategis dengan tim profesional berpengalaman 24/7." data-id="element-303" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-304" />
        <meta property="og:image:width" content="1200" data-id="element-305" />
        <meta property="og:image:height" content="630" data-id="element-306" />
        <meta property="og:image:alt" content="PT Jagat Indo Perkasa Logo - Ground Handling Indonesia" data-id="element-307" />
        <meta property="og:locale" content="id_ID" data-id="element-308" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-309" />
        <meta name="twitter:url" content="https://jagatindoperkasa.id/" data-id="element-310" />
        <meta name="twitter:title" content="PT Jagat Indo Perkasa - Layanan Ground Handling Profesional Indonesia" data-id="element-311" />
        <meta name="twitter:description" content="Penyedia layanan ground handling terkemuka di Indonesia dengan standar internasional. Melayani 4 bandara strategis dengan tim profesional 24/7." data-id="element-312" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-313" />
        <meta name="twitter:image:alt" content="PT Jagat Indo Perkasa Logo - Ground Handling Indonesia" data-id="element-314" />
        {/* Additional SEO Tags */}
        <meta name="geo.region" content="ID" data-id="element-315" />
        <meta name="geo.placename" content="Jakarta" data-id="element-316" />
        <meta name="language" content="Indonesian" data-id="element-317" />
        {/* Structured Data */}
        <script type="application/ld+json" data-id="element-318">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          '@id': 'https://jagatindoperkasa.id/#organization',
          name: 'PT Jagat Indo Perkasa',
          alternateName: 'JIP Ground Handling',
          url: 'https://jagatindoperkasa.id',
          logo: {
            '@type': 'ImageObject',
            url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png',
            width: 800,
            height: 600
          },
          description: 'Penyedia layanan ground handling profesional di Indonesia dengan standar internasional IATA & ICAO',
          email: 'jagatindoperkasa1977@gmail.com',
          telephone: '+62-811-1477-977',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Bandara Halim Perdanakusuma, Sisi Airside No. 77A',
            addressLocality: 'Jakarta',
            addressRegion: 'DKI Jakarta',
            addressCountry: 'ID'
          },
          sameAs: [],
          areaServed: [{
            '@type': 'City',
            name: 'Jakarta'
          }, {
            '@type': 'City',
            name: 'Batulicin'
          }, {
            '@type': 'City',
            name: 'Banjarbaru'
          }, {
            '@type': 'City',
            name: 'Makassar'
          }],
          serviceType: ['Ground Handling', 'Ramp Handling', 'Passenger Service', 'Cargo Handling', 'Flight Support', 'Cabin Cleaning', 'VIP Protocol Service'],
          slogan: 'Profesionalisme dan Dedikasi dalam Setiap Operasi Ground Handling'
        })}
        </script>
        <script type="application/ld+json" data-id="element-319">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          '@id': 'https://jagatindoperkasa.id/#website',
          url: 'https://jagatindoperkasa.id',
          name: 'PT Jagat Indo Perkasa',
          description: 'Layanan Ground Handling Profesional Indonesia',
          publisher: {
            '@id': 'https://jagatindoperkasa.id/#organization'
          },
          inLanguage: 'id-ID'
        })}
        </script>
      </Helmet>
      {/* Hero Slider Section */}
      <section className="relative h-[600px] md:h-[700px] overflow-hidden" data-id="element-320">
        {slides.map((slide, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} data-id="element-321">
            <div className="absolute inset-0" data-id="element-322">
              <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" data-id="element-323" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" data-id="element-324"></div>
            </div>
            <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center" data-id="element-325">
              <div className="max-w-3xl animate-fade-in" data-id="element-326">
                <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white" data-id="element-327">
                  {slide.title}
                </h1>
                <p className="text-xl md:text-2xl mb-8 text-gray-100" data-id="element-328">
                  {slide.subtitle}
                </p>
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-329">
                  <Link to="/contact" className="inline-flex items-center justify-center px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all transform hover:scale-105" data-id="element-330">
                    Hubungi Kami
                    <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-331" />
                  </Link>
                  <Link to="/services" className="inline-flex items-center justify-center px-8 py-4 bg-white text-sky-600 hover:bg-gray-100 font-semibold rounded-lg transition-all transform hover:scale-105" data-id="element-332">
                    Lihat Layanan Kami
                  </Link>
                </div>
              </div>
            </div>
          </div>)}
        {/* Navigation Arrows */}
        <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center transition-all" data-id="element-333">
          <ChevronLeftIcon className="w-6 h-6 text-white" data-id="element-334" />
        </button>
        <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center transition-all" data-id="element-335">
          <ChevronRightIcon className="w-6 h-6 text-white" data-id="element-336" />
        </button>
        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-2" data-id="element-337">
          {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentSlide ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'}`} data-id="element-338" />)}
        </div>
      </section>
      {/* Values Section */}
      <section className="py-16 bg-gray-50" data-id="element-339">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-340">
          <div className="text-center mb-12 animate-fade-in-up" data-id="element-341">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-342">
              Nilai-Nilai Perusahaan
            </h2>
            <p className="text-lg text-gray-600" data-id="element-343">
              Komitmen kami untuk memberikan layanan terbaik
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-344">
            {values.map((value, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 text-center transform hover:-translate-y-2 animate-fade-in-up" style={{
            animationDelay: `${index * 100}ms`
          }} data-id="element-345">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-sky-100 rounded-full mb-4 transition-transform duration-300 hover:scale-110" data-id="element-346">
                  <value.icon className="w-8 h-8 text-sky-600" data-id="element-347" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-348">
                  {value.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-349">{value.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Director's Message Section */}
      <section className="py-16 bg-white" data-id="element-350">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-351">
          <div className="bg-gradient-to-br from-sky-50 to-blue-50 rounded-2xl shadow-lg overflow-hidden" data-id="element-352">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 p-8 md:p-12" data-id="element-353">
              <div className="flex flex-col items-center" data-id="element-354">
                <div className="w-48 h-48 rounded-full overflow-hidden mb-4 shadow-lg" data-id="element-355">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7qHA5xTLqzhhJbzjaRyUa8/HGT.png" alt="H. GT. Denny Ramdhani, S.H." className="w-full h-full object-cover" data-id="element-356" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 text-center" data-id="element-357">
                  H. GT. Denny Ramdhani, S.H.
                </h3>
                <p className="text-sky-600 font-semibold" data-id="element-358">Director</p>
              </div>
              <div className="md:col-span-2 flex flex-col justify-center" data-id="element-359">
                <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-360">
                  Pesan Direktur
                </h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-361">
                  Dengan semangat profesionalisme dan dedikasi, kami hadir untuk
                  memberikan layanan ground handling yang mengutamakan
                  keselamatan, efisiensi, dan ketepatan dalam setiap operasi.
                  PT. Jagat Indo Perkasa berkomitmen untuk menjadi mitra
                  terpercaya dalam mendukung kelancaran operasional penerbangan
                  di Indonesia.
                </p>
                <div data-id="element-362">
                  <Link to="/about" className="inline-flex items-center px-6 py-3 bg-sky-600 hover:bg-sky-700 text-white font-semibold rounded-lg transition-all transform hover:scale-105" data-id="element-363">
                    Selengkapnya
                    <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-364" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Quick Stats */}
      <section className="py-16 bg-white" data-id="element-365">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-366">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center" data-id="element-367">
            {[{
            number: '4',
            label: 'Bandara Operasional'
          }, {
            number: '24/7',
            label: 'Layanan Tersedia'
          }, {
            number: '100%',
            label: 'Komitmen Keselamatan'
          }, {
            number: '6+',
            label: 'Layanan Utama'
          }].map((stat, index) => <div key={index} className="animate-fade-in-up transform hover:scale-105 transition-transform duration-300" style={{
            animationDelay: `${index * 150}ms`
          }} data-id="element-368">
                <div className="text-4xl md:text-5xl font-bold text-sky-600 mb-2" data-id="element-369">
                  {stat.number}
                </div>
                <div className="text-gray-600" data-id="element-370">{stat.label}</div>
              </div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="relative py-16 overflow-hidden" data-id="element-371">
        <div className="absolute inset-0" data-id="element-372">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1c6p1x1mm6Y1AUGUgtNLMb/image.png" alt="Ground Handling Team" className="w-full h-full object-cover" data-id="element-373" />
          <div className="absolute inset-0 bg-gradient-to-r from-sky-900/90 via-blue-900/85 to-sky-800/90" data-id="element-374"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center animate-fade-in-up" data-id="element-375">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-376">
            Siap Bekerja Sama dengan Kami?
          </h2>
          <p className="text-xl mb-8 text-sky-100" data-id="element-377">
            Hubungi kami untuk mendiskusikan kebutuhan ground handling Anda
          </p>
          <Link to="/contact" className="inline-flex items-center px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all transform hover:scale-105" data-id="element-378">
            Hubungi Kami Sekarang
            <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-379" />
          </Link>
        </div>
      </section>
    </div>;
}